export type CategoryOption = {
  id: string;
  title: string;
  icon: React.ReactNode;
  subcategories?: SubCategoryOption[];
};

export type SubCategoryOption = {
  id: string;
  title: string;
  description?: string;
};

interface CategoryCardProps {
  category: CategoryOption;
  selected?: boolean;
  onClick: () => void;
}

export const CategoryCard = ({
  category,
  selected = false,
  onClick,
}: CategoryCardProps) => {
  return (
    <button
      onClick={onClick}
      className={`w-full p-3 rounded-xl flex items-center gap-3 transition-all duration-200 text-left border-2 shadow-sm cursor-pointer ${
        selected
          ? "bg-green-50 border-green-600 shadow-md"
          : "bg-white border-transparent hover:bg-gray-50 hover:border-green-400"
      }`}
    >
      <div
        className={`w-12 h-12 rounded-lg flex items-center justify-center shrink-0 ${
          selected ? "bg-green-600" : "bg-gray-100"
        }`}
      >
        <div
          className={
            selected ? "text-white text-2xl" : "text-gray-600 text-2xl"
          }
        >
          {category.icon}
        </div>
      </div>
      <div className="flex-1">
        <h3
          className={`font-semibold text-sm ${
            selected ? "text-green-700" : "text-gray-900"
          }`}
        >
          {category.title}
        </h3>
      </div>
    </button>
  );
};
